import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  CreateCampaignFormContext,
  CreateCampaignFormState,
  createCampaignFormStateDefault,
  createCampaignSchemaDefault,
} from '@Forms/campaign/CreateCampaignFormContext';

export const CreateCampaignFormProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<CreateCampaignFormState>>>(
    createCampaignSchemaDefault
  );
  const methods = useForm({
    defaultValues: createCampaignFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <CreateCampaignFormContext.Provider value={value}>
      {children}
    </CreateCampaignFormContext.Provider>
  );
};
